export default function checkIsInApp(){
  // 检查是否在橘袋APP中
  if(navigator.userAgent.indexOf('NUTRIPACKS') !== -1) {
    return true;
  }
  return false;
}
